import type { Metadata } from 'next';

/**
 * Converts a backend robots directive string (e.g. "index, follow" or "noindex, nofollow")
 * into the shape expected by Next.js Metadata API.
 */
export const parseRobotsString = (robots: string): Metadata['robots'] => {
  return {
    index: robots.includes('noindex') ? false : robots.includes('index'),
    follow: robots.includes('nofollow') ? false : robots.includes('follow'),
  };
};
